import {
  SYSTEM_SETTINGS_SYSTEM_FETCH_SUCCESS,
  SYSTEM_SETTINGS_SYSTEM_FETCH_DATA,
  SAVE_SYSTEM_SETTINGS_SYSTEM_REQUEST,
  SAVE_SYSTEM_SETTINGS_SYSTEM_SUCCESS,
  CLEAR_SYSTEM_SETTINGS,
  FETCH_LICENSING_SUCCESS,
  FETCH_APPLICATION_VERSION_SUCCESS,
  FETCH_TWILIO_DATA,
  FETCH_TWILIO_DATA_SUCCESS,
  DELETE_TWILIO_REQUEST,
  DELETE_TWILIO_SUCCESS,
  SAVE_TWILIO,
  SAVE_TWILIO_SUCCESS,
  GET_TWILIO_REQUEST,
  GET_TWILIO_SUCCESS,
  UPDATE_TWILIO_REQUEST,
  UPDATE_TWILIO_SUCCESS,
} from '@constants/UHEActionTypes';
import { tableContent } from 'util/UheHelper';

const INIT_STATE = {
  loading: false,
  data: {},
  licensing: {},
  version: {},
  table: {
    list: [],
    page: {},
  },
  selectedTwilio: {},
};

/**
 * @description System reducer
 * @param  {Object} state
 * @param  {string} action
 * @return {Object}
 */
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SYSTEM_SETTINGS_SYSTEM_FETCH_SUCCESS:
      const newState = { data: action.data, loading: false };
      return Object.assign({}, state, newState);

    case SYSTEM_SETTINGS_SYSTEM_FETCH_DATA:
      return Object.assign({}, state, { loading: true });
    case SAVE_SYSTEM_SETTINGS_SYSTEM_REQUEST: {
      return { ...state, loading: true };
    }
    case SAVE_SYSTEM_SETTINGS_SYSTEM_SUCCESS: {
      const data = { ...action.payload };
      const newState = { data };
      return { ...state, ...newState, loading: false };
    }

    case CLEAR_SYSTEM_SETTINGS: {
      return { ...state, data: {} };
    }

    case FETCH_LICENSING_SUCCESS: {
      const licensing = { ...INIT_STATE.licensing, ...action.data };
      const newState = { licensing, loading: false };

      return { ...state, ...newState };
    }

    case FETCH_APPLICATION_VERSION_SUCCESS: {
      const version = { ...INIT_STATE.version, ...action.data };
      const newState = { version, loading: false };

      return { ...state, ...newState };
    }
    case FETCH_TWILIO_DATA: {
      return { ...state, loading: true };
    }

    case FETCH_TWILIO_DATA_SUCCESS: {
      const currentTable = tableContent(action.payload, state.table);
      return { ...state, table: currentTable, loading: false };
    }

    case DELETE_TWILIO_REQUEST: {
      return { ...state, loading: true };
    }

    case DELETE_TWILIO_SUCCESS: {
      return { ...state, selectedTwilio: { ...INIT_STATE.selectedTwilio }, loading: false };
    }

    case SAVE_TWILIO:
      return { ...state, loading: true };

    case SAVE_TWILIO_SUCCESS:
      return { ...state, loading: false, twilioId: action.payload.id };

    case GET_TWILIO_REQUEST: {
      return { ...state, loading: true };
    }

    case GET_TWILIO_SUCCESS: {
      return {
        ...state,
        selectedTwilio: { ...action.payload },
        loading: false,
      };
    }

    case UPDATE_TWILIO_REQUEST: {
      return { ...state, loading: true };
    }

    case UPDATE_TWILIO_SUCCESS: {
      return {
        ...state,
        selectedTwilio: { ...state.selectedTwilio, ...action.payload },
        loading: false,
      };
    }

    default:
      return state;
  }
};
